import BackButton from "components/Button/BackButton"
import DeleteButton from "components/Button/DeleteButton"
import SaveButton from "components/Button/SaveButton"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { EmptyString, FormTypeAdd, FormTypeEdit, StatusCodeActive, StatusCodeDelete } from "utils/Constant"
import { removeNonNumeric } from "utils/helpers"
import UnDeleteButton from "components/Button/UnDeleteButton"
import { FormCard, PagesFormTitle } from "components/Cards"
import { useModal } from "context/ModalContext"
import { useCallApi } from "api/apiHooks"

export default function CustomerForm(){
    const navigate = useNavigate()
    const { fetchInsertCustomer, fetchUpdateCustomer, fetchCustomerById, fetchDeleteCustomer} = useCallApi()
    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramCustomerId = queryString.get("customerId")

    const [customerName, setCustomerName] = useState(EmptyString)
    const [address, setAddress] = useState(EmptyString)
    const [phone, setPhone] = useState(EmptyString)
    const [createDate, setCreateDate] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)

    // Button Event
    const saveBtnClick = async () => {
        if (validateForm()){
            const isConfirmed = await confirm()

            if (isConfirmed) {
                showLoading()

                try{
                    if (formType === FormTypeAdd){
                        const res = await fetchInsertCustomer(customerName.trim(), address, phone)

                        if (!res) return

                        showSuccess({
                            onSuccess: () => {
                                navigate("/customer") 
                            }
                        })
                    }else{
                        const res = await fetchUpdateCustomer(paramCustomerId, customerName.trim(), address, phone)

                        if (!res) return

                        showSuccess({
                            onSuccess: () => {
                                navigate("/customer") 
                            }
                        })
                    }
                } finally{
                    hideLoading()
                }
            }
        }
    }
    const deleteBtnClick = async () => {
        const isConfirmed = await confirm()

        if (isConfirmed) {
            showLoading()

            try{
                const res = await fetchDeleteCustomer(paramCustomerId, status)

                if (!res) return

                showSuccess({
                    onSuccess: () => {
                        navigate("/customer") 
                    }
                })
            } finally{
                hideLoading()
            }
        }
    }
    const backBtnClick = () => {
        navigate('/customer')
    }

    function validateForm(){
        let errorCount = 0

        if (errorCount > 0){
            return false
        }else{
            return true
        }
    }

    useEffect(() => {
        const loadCustomer = async () => {
            if (formType ===  FormTypeEdit){
                showLoading()

                try{
                    const res = await fetchCustomerById(paramCustomerId)

                    if (!res) return

                    let data = res.data

                    setCustomerName(data.customerName)
                    setAddress(data.address)
                    setPhone(data.phone)
                    setStatus(data.status)
                    setCreateDate(data.createDate)
                    setUpdateDate(data.updateDate)
                    setUpdateBy(data.updateBy)
                } finally{
                    hideLoading()
                }
            }
        }
        
        loadCustomer()
    }, [])

    return (
        <div className="flex flex-col gap-2">
            <PagesFormTitle 
                title='Detail Pelanggan'
                formType={formType}
                status={status}
                createDate={createDate}
                updateDate={updateDate}
                updateBy={updateBy}
            />

            <div className="mt-5 flex flex-col gap-3">
                <FormCard title='Nama Pelanggan'>
                    <input className="input" value={customerName} onChange={(e) => { setCustomerName(e.target.value.toUpperCase()) }} maxLength={100} />
                </FormCard>

                <FormCard title='Alamat'>
                    <input className="input" value={address} onChange={(e) => { setAddress(e.target.value.toUpperCase()) }} maxLength={100} />
                </FormCard>

                <FormCard title='No HP'>
                    <input className="input" value={phone} onChange={(e) => { setPhone(removeNonNumeric(e.target.value)) }} maxLength={16} />
                </FormCard>
            </div>

            <div className="mt-5 flex flex-wrap justify-end w-full gap-2">
                <SaveButton onClick={saveBtnClick} visible={true} />
                <DeleteButton onClick={deleteBtnClick} visible={ formType === FormTypeAdd ? false : (status === StatusCodeActive ? true : false) } />
                <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === StatusCodeDelete ? true : false) : false} />
                <BackButton onClick={backBtnClick}  />
            </div>
        </div>
    )
}